import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '../store'
import { i18n } from '../plugins/i18n'
import { setupAxios } from '../plugins/axios'
import { setupStoreCache } from '../plugins/store-cache'
import '../plugins/antd-ui'
import '../plugins/global-methods'
import '../plugins/vue-ls'
import '../assets/css/variable.less'

setupAxios(store, i18n, router)
setupStoreCache()

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
